import { inject, Injectable, Signal } from '@angular/core';
import { CurrentUserService } from './current-user.service';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IdTokenResult, User } from '@angular/fire/auth';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class CurrentIdTokenService {
  private readonly currentUserService = inject(CurrentUserService);

  readonly currentUserIdToken: Signal<IdTokenResult | null> = toSignal(
    this.currentUserIdToken$(),
    { initialValue: null },
  );

  currentUserIdToken$(): Observable<IdTokenResult | null> {
    return this.currentUserService.currentUser$().pipe(
      switchMap(async (user: User | null) => {
        return user ? await user.getIdTokenResult() : null;
      }),
    );
  }
}
